import { Box, Flex } from "@chakra-ui/react";

const Pagination = ({
  currentIndex,
  total,
}: {
  currentIndex: number;
  total: number;
}) => {
  return (
    <Flex
      sx={{
        height: "4px",
        width: "100%",
        gap: "5px",
      }}
      align={"center"}
    >
      {new Array(total).fill(0).map((_, index) => (
        <Flex
          key={index}
          sx={{
            flex: 1,
            background: "#DEDEDE",
            height: "4px",
            borderRadius: "100px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: currentIndex === index ? "100%" : "0%",
              height: "100%",
              background: "#D8762B",
              borderRadius: "100px",
              transition: "width 5s ease",
              opacity: currentIndex === index ? 1 : 0,
              position: "absolute",
              left: 0,
              top: 0,
            }}
          ></Box>

          {currentIndex > index && (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                background: "#D8762B",
                borderRadius: "100px",
                position: "absolute",
                left: 0,
                top: 0,
              }}
            ></Box>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export default Pagination;
